/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconErrorFilled8 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled8(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 8 8" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 .667a3.333 3.333 0 1 0 0 6.666A3.333 3.333 0 0 0 4 .667Zm-.333 4L3.5 2h1l-.166 2.667h-.667ZM4 6.332a.583.583 0 1 0 0-1.167.583.583 0 0 0 0 1.167Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconErrorFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6 1a5 5 0 1 0 0 10A5 5 0 0 0 6 1Zm-.5 6-.25-4h1.5L6.5 7h-1ZM6 9.5a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconErrorFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.334Zm-.667 8L7 4h2l-.334 5.334H7.333ZM8 12.668a1.167 1.167 0 1 0 0-2.333 1.167 1.167 0 0 0 0 2.333Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconErrorFilled20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm-.833 10L8.75 5h2.5l-.416 6.666H9.167ZM10 15.832a1.458 1.458 0 1 0 0-2.917 1.458 1.458 0 0 0 0 2.917Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconErrorFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm-1 12-.5-8h3l-.5 8h-2Zm1 5a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconErrorFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconErrorFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '8':
            return <IconErrorFilled8 {...iconProps} />;
        case '12':
            return <IconErrorFilled12 {...iconProps} />;
        case '16':
            return <IconErrorFilled16 {...iconProps} />;
        case '20':
            return <IconErrorFilled20 {...iconProps} />;
        case '24':
            return <IconErrorFilled24 {...iconProps} />;
        default:
            return <IconErrorFilled24 {...iconProps} />;
    }
});
